import * as React from 'react';
import { cn } from '@/lib/utils';

const Input = ({ className, type, ...props }: React.ComponentProps<'input'>) => {
  return (
    <input
      type={type}
      className={cn(
        'placeholder:text-muted-foreground bg-transparent border border-border flex h-10 w-full min-w-0 rounded-sm px-3 py-1 shadow-xs transition-[color,box-shadow] outline-none text-sm',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
};

export { Input };
